export const FORTUNE_1000_COMPANIES: string[] = [
  "3M",
  "A-Mark Precious Metals",
  "A.O. Smith",
  "ABM Industries",
  "ADT",
  "AECOM",
  "AES",
  "AGCO",
  "AGNC Investment",
  "AIG",
  "AMC Entertainment Holdings",
  "AMN Healthcare Services",
  "APA",
  "APi Group",
  "ARKO",
  "ASGN",
  "AT&T",
  "ATI",
  "AbbVie",
  "Abbott Laboratories",
  "Abercrombie & Fitch",
  "Academy Sports and Outdoors",
  "Acadia Healthcare",
  "Ace Hardware",
  "Acuity",
  "AdaptHealth",
  "Adobe",
  "Advance Auto Parts",
  "Advanced Drainage Systems",
  "Advanced Micro Devices",
  "Advantage Solutions",
  "Aflac",
  "Agilent Technologies",
  "Agilon health",
  "Air Lease",
  "Air Products & Chemicals",
  "Airbnb",
  "Akamai Technologies",
  "Alaska Air Group",
  "Albemarle",
  "Albertsons",
  "Alcoa",
  "Alexandria Real Estate Equities",
  "Alight",
  "Align Technology",
  "Alignment Healthcare",
  "Alliant Energy",
  "Allison Transmission Holdings",
  "Allstate",
  "Ally Financial",
  "Alpha Metallurgical Resources",
  "Alphabet",
  "Altice USA",
  "Altria Group",
  "Amazon",
  "Ameren",
  "American Airlines Group",
  "American Axle & Manufacturing",
  "American Eagle Outfitters",
  "American Electric Power",
  "American Express",
  "American Family Insurance Group",
  "American Financial Group",
  "American Tower",
  "American Water Works",
  "Americold Realty Trust",
  "Ameriprise Financial",
  "Ametek",
  "Amgen",
  "Amica Mutual Insurance",
  "Amkor Technology",
  "Amneal Pharmaceuticals",
  "Amphenol",
  "Analog Devices",
  "Andersons",
  "Annaly Capital Management",
  "Antero Resources",
  "Anywhere Real Estate",
  "Apollo Global Management",
  "AppLovin",
  "Apple",
  "Applied Industrial Technologies",
  "Applied Materials",
  "AptarGroup",
  "Aramark",
  "ArcBest",
  "Archer Daniels Midland",
  "Ardent Health Partners",
  "Ares Management",
  "Arista Networks",
  "Arrow Electronics",
  "Arthur J. Gallagher",
  "Asbury Automotive Group",
  "Assurant",
  "Atkore",
  "Atlassian",
  "Atmos Energy",
  "Auto-Owners Insurance",
  "AutoNation",
  "AutoZone",
  "Autodesk",
  "Autoliv",
  "Automatic Data Processing",
  "AvalonBay Communities",
  "Avantor",
  "Avery Dennison",
  "Avient",
  "Avis Budget Group",
  "Avnet",
  "BJ's Wholesale Club",
  "BOK Financial",
  "BWX Technologies",
  "BXP",
  "Baker Hughes",
  "Bakkt Holdings",
  "Ball",
  "Bank OZK",
  "Bank of America",
  "Bank of New York (BNY)",
  "Bath & Body Works",
  "Baxter International",
  "Becton Dickinson",
  "Berkshire Hathaway",
  "Berry Global Group",
  "Best Buy",
  "BioMarin Pharmaceutical",
  "Biogen",
  "BlackRock",
  "Blackstone",
  "Block",
  "Bloomin' Brands",
  "BlueLinx Holdings",
  "Boeing",
  "Boise Cascade",
  "Booking Holdings",
  "Booz Allen Hamilton Holding",
  "BorgWarner",
  "Boston Scientific",
  "Boyd Gaming",
  "Bread Financial Holdings",
  "Bright Horizons Family Solutions",
  "BrightSpring Health Services",
  "BrightView Holdings",
  "Brighthouse Financial",
  "Brink's",
  "Brinker International",
  "Bristol-Myers Squibb",
  "Broadcom",
  "Broadridge Financial Solutions",
  "Brookdale Senior Living",
  "Brown & Brown",
  "Brown-Forman",
  "Bruker",
  "Brunswick",
  "Builders FirstSource",
  "Burlington Stores",
  "C.H. Robinson Worldwide",
  "CACI International",
  "CBRE Group",
  "CDW",
  "CF Industries Holdings",
  "CHS",
  "CME Group",
  "CMS Energy",
  "CNO Financial Group",
  "CSX",
  "CUNA Mutual Group",
  "CVS Health",
  "Cabot",
  "Cadence Bank",
  "Cadence Design Systems",
  "Caesars Entertainment",
  "Caleres",
  "California Resources",
  "Calumet",
  "Campbell's",
  "Camping World Holdings",
  "Capital One Financial",
  "CarMax",
  "Cardinal Health",
  "Carlisle",
  "Carlyle Group",
  "Carpenter Technology",
  "Carrier Global",
  "Carter's",
  "Carvana",
  "Casey's General Stores",
  "Catalent",
  "Caterpillar",
  "Cboe Global Markets",
  "Celanese",
  "Cencora",
  "Centene",
  "CenterPoint Energy",
  "Central Garden & Pet",
  "Century Communities",
  "ChampionX",
  "Charles River Laboratories International",
  "Charles Schwab",
  "Chart Industries",
  "Charter Communications",
  "Cheesecake Factory",
  "Chefs' Warehouse",
  "Chemours",
  "Cheniere Energy",
  "Chevron",
  "Chewy",
  "Chipotle Mexican Grill",
  "Chord Energy",
  "Church & Dwight",
  "Churchill Downs",
  "Ciena",
  "Cigna Group",
  "Cincinnati Financial",
  "Cinemark Holdings",
  "Cintas",
  "Cisco Systems",
  "Citigroup",
  "Citizens Financial Group",
  "Civitas Resources",
  "Clean Harbors",
  "Cleveland-Cliffs",
  "Clorox",
  "CoStar Group",
  "Coca-Cola",
  "Coca-Cola Consolidated",
  "Cognizant Technology Solutions",
  "Coherent",
  "Coinbase Global",
  "Colgate-Palmolive",
  "Columbia Banking System",
  "Columbia Sportswear",
  "Comcast",
  "Comerica",
  "Comfort Systems USA",
  "CommScope Holding",
  "Commercial Metals",
  "Community Health Systems",
  "Compass",
  "Conagra Brands",
  "Concentrix",
  "Conduent",
  "ConocoPhillips",
  "Consolidated Edison",
  "Constellation Brands",
  "Constellation Energy",
  "Continental Resources",
  "Cooper Cos.",
  "Cooper-Standard Holdings",
  "Copart",
  "Core & Main",
  "Corebridge Financial",
  "Cornerstone Building Brands",
  "Corning",
  "Corpay",
  "Corteva",
  "Costco Wholesale",
  "Coterra Energy",
  "Coty",
  "Country Financial",
  "Coupang",
  "Cracker Barrel Old Country Store",
  "Crescent Energy",
  "Crocs",
  "CrossAmerica Partners",
  "CrowdStrike Holdings",
  "Crown Castle",
  "Crown Holdings",
  "Cullen/Frost Bankers",
  "Cummins",
  "Curtiss-Wright",
  "D.R. Horton",
  "DTE Energy",
  "DXC Technology",
  "DaVita",
  "Dana",
  "Danaher",
  "Darden Restaurants",
  "Darling Ingredients",
  "Datadog",
  "Deckers Outdoor",
  "Deere",
  "Delek US Holdings",
  "Dell Technologies",
  "Delta Air Lines",
  "Dentsply Sirona",
  "Designer Brands",
  "Devon Energy",
  "DexCom",
  "Diamondback Energy",
  "Dick's Sporting Goods",
  "Diebold Nixdorf",
  "Digital Realty Trust",
  "Dillard's",
  "Discover",
  "DocuSign",
  "Dollar General",
  "Dollar Tree",
  "Dominion Energy",
  "Domino's Pizza",
  "Domtar",
  "Donaldson",
  "DoorDash",
  "Dover",
  "Dow",
  "DraftKings",
  "Dream Finders Homes",
  "DuPont",
  "Duke Energy",
  "Dycom Industries",
  "EMCOR Group",
  "EOG Resources",
  "EPAM Systems",
  "EQT",
  "ESAB",
  "East West Bancorp",
  "Eastman Chemical",
  "Ebay",
  "EchoStar",
  "Ecolab",
  "Edison International",
  "Edwards Lifesciences",
  "Elanco Animal Health",
  "Electronic Arts",
  "Elevance Health",
  "Eli Lilly",
  "Emerson Electric",
  "Encompass Health",
  "Endeavor Group Holdings",
  "EnerSys",
  "Energizer Holdings",
  "Energy Transfer",
  "Ensign Group",
  "Entegris",
  "Entergy",
  "Enterprise Products Partners",
  "Equifax",
  "Equinix",
  "Equitable Holdings",
  "Equity Residential",
  "Erie Insurance Group",
  "Estee Lauder",
  "Etsy",
  "Euronet Worldwide",
  "Evercore",
  "Evergy",
  "Eversource Energy",
  "Everus Construction Group",
  "Exact Sciences",
  "Exelon",
  "Expand Energy",
  "Expedia Group",
  "Expeditors Intl. of Washington",
  "Extra Space Storage",
  "Exxon Mobil",
  "F5",
  "FM",
  "FMC",
  "FTI Consulting",
  "Fannie Mae",
  "Farmers Insurance Exchange",
  "Fastenal",
  "FedEx",
  "Federated Mutual Insurance",
  "Ferguson Enterprises",
  "Fidelity National Financial",
  "Fidelity National Information Services",
  "Fifth Third Bancorp",
  "First American Financial",
  "First Citizens BancShares",
  "First Horizon",
  "First National of Nebraska",
  "First Solar",
  "FirstCash Holdings",
  "FirstEnergy",
  "Fiserv",
  "Five Below",
  "Flagstar Financial",
  "Floor & Decor Holdings",
  "Flowers Foods",
  "Flowserve",
  "Fluence Energy",
  "Fluor",
  "Foot Locker",
  "Ford Motor",
  "Fortinet",
  "Fortive",
  "Fortrea Holdings",
  "Fortune Brands Innovations",
  "Fox",
  "Franklin Resources",
  "Freddie Mac",
  "Freeport-McMoRan",
  "Frontier Communications",
  "Frontier Group Holdings",
  "G-III Apparel Group",
  "GE HealthCare Technologies",
  "GE Vernova",
  "GMS",
  "GXO Logistics",
  "GameStop",
  "Gap",
  "Garrett Motion",
  "Gartner",
  "Gen Digital",
  "Generac Holdings",
  "General Dynamics",
  "General Electric (GE Aerospace)",
  "General Mills",
  "General Motors",
  "Genesis Energy",
  "Genuine Parts",
  "Genworth Financial",
  "Gilead Sciences",
  "Global Partners",
  "Global Payments",
  "Globe Life",
  "GoDaddy",
  "Goldman Sachs Group",
  "Goodyear Tire & Rubber",
  "Graham Holdings",
  "Granite Construction",
  "Graphic Packaging Holding",
  "Gray Media",
  "Graybar Electric",
  "Greenbrier",
  "Greif",
  "Grocery Outlet Holding",
  "Group 1 Automotive",
  "Guardian Life Ins. Co. of America",
  "Guess",
  "GuideWell Mutual Holding",
  "H&R Block",
  "H.B. Fuller",
  "HCA Healthcare",
  "HEICO",
  "HF Sinclair",
  "HP",
  "Halliburton",
  "Hanesbrands",
  "Hanover Insurance Group",
  "Harley-Davidson",
  "Hartford Insurance Group",
  "Hasbro",
  "Hawaiian Electric Industries",
  "Healthpeak Properties",
  "Helmerich & Payne",
  "Henry Schein",
  "Herc Holdings",
  "Hershey",
  "Hertz Global Holdings",
  "Hess",
  "Hewlett Packard Enterprise",
  "Hillenbrand",
  "Hilton Grand Vacations",
  "Hilton Worldwide Holdings",
  "Hologic",
  "Home Depot",
  "Honeywell International",
  "Hormel Foods",
  "Host Hotels & Resorts",
  "Hovnanian Enterprises",
  "Howmet Aerospace",
  "Hub Group",
  "Hubbell",
  "Humana",
  "Huntington Bancshares",
  "Huntington Ingalls Industries",
  "Huntsman",
  "Hyatt Hotels",
  "Hyster-Yale",
  "IAC",
  "IBM",
  "IDEX",
  "IDEXX Laboratories",
  "IES Holdings",
  "IQVIA Holdings",
  "ITT",
  "Icahn Enterprises",
  "Illinois Tool Works",
  "Illumina",
  "Incyte",
  "Ingersoll Rand",
  "Ingles Markets",
  "Ingram Micro Holding",
  "Ingredion",
  "Insight Enterprises",
  "Insperity",
  "Instacart",
  "Installed Building Products",
  "Intel",
  "Interactive Brokers Group",
  "Intercontinental Exchange",
  "International Flavors & Fragrances",
  "International Paper",
  "Interpublic Group",
  "Intuit",
  "Intuitive Surgical",
  "Iron Mountain",
  "J.B. Hunt Transport Services",
  "J.M. Smucker",
  "JELD-WEN Holding",
  "JPMorgan Chase",
  "Jabil",
  "Jackson Financial",
  "Jacobs Solutions",
  "Jefferies Financial Group",
  "JetBlue Airways",
  "Johnson & Johnson",
  "Jones Financial (Edward Jones)",
  "Jones Lang LaSalle",
  "Juniper Networks",
  "KB Home",
  "KBR",
  "KKR",
  "KLA",
  "Kaiser Aluminum",
  "Kellanova",
  "Kelly Services",
  "Kemper",
  "Kenvue",
  "Keurig Dr Pepper",
  "KeyCorp",
  "Keysight Technologies",
  "Kimberly-Clark",
  "Kinder Morgan",
  "KinderCare Learning",
  "Kirby",
  "Knife River",
  "Knight-Swift Transportation Hldgs.",
  "Kohl's",
  "Korn Ferry",
  "Kraft Heinz",
  "Kroger",
  "Kyndryl Holdings",
  "L3Harris Technologies",
  "LCI Industries",
  "LKQ",
  "LPL Financial Holdings",
  "Labcorp Holdings",
  "Lam Research",
  "Lamb Weston Holdings",
  "Land O'Lakes",
  "Landstar System",
  "Las Vegas Sands",
  "Lazard",
  "Lear",
  "Leggett & Platt",
  "Leidos Holdings",
  "Lennar",
  "Lennox International",
  "Levi Strauss",
  "Liberty Energy",
  "Liberty Media",
  "Liberty Mutual Insurance Group",
  "Light & Wonder",
  "Lincoln Electric Holdings",
  "Lincoln National",
  "Lineage",
  "Lithia Motors",
  "Live Nation Entertainment",
  "Lockheed Martin",
  "Loews",
  "Louisiana-Pacific",
  "Lowe's",
  "Lululemon athletica",
  "Lumen Technologies",
  "Lyft",
  "M&T Bank",
  "M/I Homes",
  "MGM Resorts International",
  "MKS",
  "MRC Global",
  "MSC Industrial Direct",
  "MSCI",
  "MYR Group",
  "Macy's",
  "ManpowerGroup",
  "Marathon Petroleum",
  "Markel Group",
  "Marriott International",
  "Marriott Vacations Worldwide",
  "Marsh & McLennan",
  "Martin Marietta Materials",
  "Marvell Technology",
  "MasTec",
  "Masco",
  "Massachusetts Mutual Life Insurance",
  "MasterBrand",
  "Mastercard",
  "Matador Resources",
  "Match Group",
  "Matson",
  "Mattel",
  "Maximus",
  "McCormick",
  "McDonald's",
  "McKesson",
  "Medical Mutual of Ohio",
  "Merck",
  "Mercury General",
  "Meritage Homes",
  "MetLife",
  "Meta Platforms",
  "Mettler-Toledo International",
  "Microchip Technology",
  "Micron Technology",
  "Microsoft",
  "Middleby",
  "MillerKnoll",
  "Moderna",
  "ModivCare",
  "Mohawk Industries",
  "Molina Healthcare",
  "Molson Coors Beverage",
  "Mondelez International",
  "Monster Beverage",
  "Moody's",
  "Moog",
  "Morgan Stanley",
  "Mosaic",
  "Motorola Solutions",
  "Mueller Industries",
  "Murphy Oil",
  "Murphy USA",
  "Mutual of Omaha",
  "NCR Atleos",
  "NCR Voyix",
  "NGL Energy Partners",
  "NLV Financial",
  "NOV",
  "NRG Energy",
  "NVR",
  "Nasdaq",
  "Nationwide",
  "Navient",
  "NetApp",
  "Netflix",
  "New York Life Insurance",
  "NewMarket",
  "Newell Brands",
  "Newmark Group",
  "Newmont",
  "News Corp.",
  "Nexstar Media Group",
  "NextEra Energy",
  "NiSource",
  "Nike",
  "Nordson",
  "Nordstrom",
  "Norfolk Southern",
  "Northern Trust",
  "Northrop Grumman",
  "Northwestern Mutual",
  "Nucor",
  "Nvidia",
  "O'Reilly Automotive",
  "O-I Glass",
  "ODP",
  "OGE Energy",
  "ON Semiconductor",
  "Occidental Petroleum",
  "Old Dominion Freight Line",
  "Old National Bancorp",
  "Old Republic International",
  "Olin",
  "Omnicom Group",
  "OneMain Holdings",
  "Oneok",
  "Opendoor Technologies",
  "Option Care Health",
  "Oracle",
  "Organon",
  "Oscar Health",
  "Oshkosh",
  "Otis Worldwide",
  "Ovintiv",
  "Owens & Minor",
  "Owens Corning",
  "PBF Energy",
  "PC Connection",
  "PENN Entertainment",
  "PG&E",
  "PNC Financial Services Group",
  "PPG Industries",
  "PPL",
  "PVH",
  "Paccar",
  "Pacific Life",
  "Packaging Corp. of America",
  "Palantir Technologies",
  "Palo Alto Networks",
  "Par Pacific Holdings",
  "Paramount Global",
  "Parker-Hannifin",
  "Parsons",
  "Patrick Industries",
  "Patterson",
  "Patterson-UTI Energy",
  "PayPal Holdings",
  "Paychex",
  "Peabody Energy",
  "Peloton Interactive",
  "Penn Mutual Life Insurance",
  "PennyMac Financial Services",
  "Penske Automotive Group",
  "PepsiCo",
  "Performance Food Group",
  "Permian Resources",
  "Petco Health and Wellness",
  "Peter Kiewit Sons'",
  "Pfizer",
  "Philip Morris International",
  "Phillips 66",
  "Phinia",
  "Pinnacle Financial Partners",
  "Pinnacle West Capital",
  "Pinterest",
  "Pitney Bowes",
  "Plains GP Holdings",
  "Plexus",
  "Polaris",
  "Pool",
  "Popular",
  "Portland General Electric",
  "Post Holdings",
  "PriceSmart",
  "Primerica",
  "Primo Brands",
  "Primoris Services",
  "Principal Financial",
  "Procter & Gamble",
  "Progressive",
  "Prologis",
  "Prudential Financial",
  "Public Service Enterprise Group",
  "Public Storage",
  "Publix Super Markets",
  "Puget Energy",
  "PulteGroup",
  "Pure Storage",
  "QVC Group",
  "QXO Building Products",
  "Qorvo",
  "Quad/Graphics",
  "Qualcomm",
  "Quanta Services",
  "Quest Diagnostics",
  "QuidelOrtho",
  "RH",
  "RPM International",
  "RTX",
  "RXO",
  "Rackspace Technology",
  "Radius Recycling",
  "Ralph Lauren",
  "Raymond James Financial",
  "Realty Income",
  "Regal Rexnord",
  "Regeneron Pharmaceuticals",
  "Regions Financial",
  "Reinsurance Group of America",
  "Reliance",
  "Republic Services",
  "ResMed",
  "Resideo Technologies",
  "Revvity",
  "Rithm Capital",
  "Rivian Automotive",
  "Robert Half",
  "Robinhood Markets",
  "Roblox",
  "Rocket Companies",
  "Rockwell Automation",
  "Roku",
  "Rollins",
  "Roper Technologies",
  "Ross Stores",
  "Rush Enterprises",
  "Ryder System",
  "Ryerson Holding",
  "S&P Global",
  "SBA Communications",
  "SLM",
  "SM Energy",
  "SS&C Technologies Holdings",
  "Sabre",
  "Saia",
  "Salesforce",
  "Sally Beauty Holdings",
  "Sanmina",
  "ScanSource",
  "Schneider National",
  "Science Applications International",
  "Scotts Miracle-Gro",
  "Seaboard",
  "Sealed Air",
  "Securian Financial Group",
  "Select Medical Holdings",
  "Selective Insurance Group",
  "Sempra",
  "Sentry Insurance Group",
  "Service Corp. International",
  "ServiceNow",
  "Sherwin-Williams",
  "Shift4 Payments",
  "Silgan Holdings",
  "Simon Property Group",
  "Sinclair",
  "Sirius XM Holdings",
  "SiteOne Landscape Supply",
  "Six Flags Entertainment",
  "Skechers U.S.A.",
  "SkyWest",
  "Skyworks Solutions",
  "Snap",
  "Snap-on",
  "Snowflake",
  "SoFi Technologies",
  "Solventum",
  "Somnigroup International",
  "Sonic Automotive",
  "Sonoco Products",
  "Southern",
  "Southwest Airlines",
  "Southwest Gas Holdings",
  "SpartanNash",
  "Spectrum Brands Holdings",
  "Spirit AeroSystems Holdings",
  "Spirit Aviation Holdings",
  "Sprouts Farmers Market",
  "Stagwell",
  "StandardAero",
  "Stanley Black & Decker",
  "Starbucks",
  "State Farm Insurance",
  "State Street",
  "Steel Dynamics",
  "Steelcase",
  "Stifel Financial",
  "StoneX Group",
  "Stryker",
  "Sun Communities",
  "Super Micro Computer",
  "Surgery Partners",
  "Sylvamo",
  "Synchrony Financial",
  "Synopsys",
  "Synovus Financial",
  "Sysco",
  "T. Rowe Price",
  "TD Synnex",
  "TEGNA",
  "TIAA",
  "TJX",
  "TPG",
  "Take-Two Interactive Software",
  "Tapestry",
  "Targa Resources",
  "Target",
  "Taylor Morrison Home",
  "Teledyne Technologies",
  "Teleflex",
  "Telephone & Data Systems",
  "TelevisaUnivision",
  "Tenet Healthcare",
  "Teradyne",
  "Terex",
  "Tesla",
  "Tetra Tech",
  "Texas Instruments",
  "Texas Roadhouse",
  "Textron",
  "Thermo Fisher Scientific",
  "Thor Industries",
  "Thrivent Financial for Lutherans",
  "Timken",
  "Titan Machinery",
  "Toast",
  "Toll Brothers",
  "TopBuild",
  "Topgolf Callaway Brands",
  "Toro",
  "Tractor Supply",
  "TransDigm Group",
  "TransUnion",
  "Travel + Leisure",
  "Travelers",
  "TreeHouse Foods",
  "Tri Pointe Homes",
  "TriNet Group",
  "Trimble",
  "Trinity Industries",
  "Truist Financial",
  "Tutor Perini",
  "Twilio",
  "Tyson Foods",
  "U-Haul Holding",
  "U.S. Bancorp",
  "UFP Industries",
  "UGI",
  "UL Solutions",
  "UMB Financial",
  "UPS",
  "US Foods Holding",
  "USAA",
  "Uber Technologies",
  "Ulta Beauty",
  "Under Armour",
  "Union Pacific",
  "United Airlines Holdings",
  "United Natural Foods",
  "United Rentals",
  "United States Steel",
  "United Therapeutics",
  "UnitedHealth Group",
  "Universal",
  "Universal Health Services",
  "Unum Group",
  "Upbound Group",
  "Urban Outfitters",
  "V2X",
  "VF",
  "VICI Properties",
  "Vail Resorts",
  "Valero Energy",
  "Valley National Bancorp",
  "Valmont Industries",
  "Veeva Systems",
  "Ventas",
  "Venture Global",
  "Veralto",
  "Verisk Analytics",
  "Verizon Communications",
  "Vertex Pharmaceuticals",
  "Vertiv Holdings",
  "Vestis",
  "Viasat",
  "Viatris",
  "Victoria's Secret",
  "Virtu Financial",
  "Visa",
  "Vishay Intertechnology",
  "Vista Outdoor",
  "Visteon",
  "Vistra",
  "Vontier",
  "Voya Financial",
  "Vulcan Materials",
  "W.R. Berkley",
  "W.W. Grainger",
  "WEC Energy Group",
  "WESCO International",
  "WK Kellogg",
  "Walgreens Boots Alliance",
  "Walmart",
  "Walt Disney",
  "Warner Bros. Discovery",
  "Warner Music Group",
  "Waste Management",
  "Waters",
  "Watsco",
  "Wayfair",
  "Webster Financial",
  "Weis Markets",
  "Wells Fargo",
  "Welltower",
  "Werner Enterprises",
  "West Pharmaceutical Services",
  "Western & Southern Financial Group",
  "Western Alliance Bancorp.",
  "Western Digital",
  "Western Midstream Partners",
  "Western Union",
  "Westinghouse Air Brake Technologies",
  "Westlake",
  "Weyerhaeuser",
  "Whirlpool",
  "Williams",
  "Williams-Sonoma",
  "Winnebago Industries",
  "Wintrust Financial",
  "Woodward",
  "Workday",
  "World Kinect",
  "Worthington Steel",
  "Wynn Resorts",
  "XPO",
  "Xcel Energy",
  "Xerox Holdings",
  "Xylem",
  "Yum Brands",
  "Yum China Holdings",
  "Zebra Technologies",
  "Zimmer Biomet Holdings",
  "Zions Bancorp.",
  "Zoetis",
  "Zoom Communications",
  "eXp World Holdings",
  "iHeartMedia"
];
